// extracted by mini-css-extract-plugin
export var avatarContainer = "_e4-0";
export var avatarTypingWave = "_e4-i";
export var gray = "_e4-f";
export var green = "_e4-c";
export var icon = "_e4-9";
export var image = "_e4-1";
export var lg = "_e4-6";
export var md = "_e4-5";
export var presenceDot = "_e4-b";
export var red = "_e4-d";
export var sm = "_e4-4";
export var status = "_e4-a";
export var typingDot = "_e4-h";
export var typingPill = "_e4-g";
export var xl = "_e4-7";
export var xs = "_e4-3";
export var xxl = "_e4-8";
export var xxs = "_e4-2";
export var yellow = "_e4-e";